import { css } from 'styled-components';
import GAME_IDS from 'a/hub/data/GameIds';

export const GAME_ID = GAME_IDS.STICKER_BOOK;

export const LEVEL_COUNT = 17;

export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
};

export const ACTION_TYPES = {
  LOAD_CURRICULUM: 'LOAD_CURRICULUM',
  LOAD_LEVEL: 'LOAD_LEVEL',
  SET_DRAGGABLE_STATE: 'SET_DRAGGABLE_STATE',
  DROP_STICKER: 'DROP_STICKER',
  SELECT_STICKER_VIA_KEYBOARD: 'SELECT_STICKER_VIA_KEYBOARD',
  CYCLE_SCENE_VIA_KEYBOARD: 'CYCLE_SCENE_VIA_KEYBOARD',
  INCREMENT_HELP_INDEX: 'INCREMENT_HELP_INDEX',
  CLEAR_SCENE_FEEDBACK: 'CLEAR_SCENE_FEEDBACK',
  INCREMENT_MASTERY_SCORE: 'INCREMENT_MASTERY_SCORE',
  QUICK_ROUND: 'QUICK_ROUND',
};

export const OBJECTS_PER_SCENE = 9;

export const DRAGGABLE_TYPES = { STICKER: 'sticker' };

export const LEVEL_MODES = {
  PICTURES: 'Pictures',
  WORDS: 'Words',
};

export const GRID_MARGIN = 15;

export const GRID_COORDINATES = [
  css`transform: translate(${GRID_MARGIN}px, ${GRID_MARGIN}px);`,
  css`left: 100%; transform: translate(calc(-100% - ${GRID_MARGIN}px), ${GRID_MARGIN}px);`,
  css`top: 100%; transform: translate(${GRID_MARGIN}px, calc(-100% - ${GRID_MARGIN}px));`,
  css`top: 100%; left: 100%; transform: translate(calc(-100% - ${GRID_MARGIN}px), calc(-100% - ${GRID_MARGIN}px));`,
  css`top: 50%; left: 50%; transform: translate(-50%, -50%);`,
];
